import { usePrototypeViewContext } from './usePrototypeViewContext'

/**
 * Returns the id of the artboard used to start the current prototype.
 * In most cases this will return the official artboard used
 * as the starting point. However, in the cases of "orphan prototype"
 * (prototypes for which we don't know for legacy reasons what is the official starting point),
 * it will return the id of first artboard the user landed on when opening
 * the prototype.
 */
export function usePrototypeStartArtboardId() {
  const { currentPrototype } = usePrototypeViewContext()

  return currentPrototype.type === 'orphan_prototype'
    ? currentPrototype.initialArtboardId
    : currentPrototype.startPointArtboardId
}
